import React from 'react';
import {useTranslation} from 'react-i18next';

export const NotFoundView: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className="h-screen flex justify-center items-center">
      <div className="min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
        <div className="mx-auto max-w-max">
          <main className="sm:flex">
            <p className="text-4xl font-bold tracking-tight text-blue sm:text-5xl">404</p>
            <div className="sm:ml-6">
              <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">{t('Page not found')}</h1>
                <p className="mt-1 text-base text-gray-500">
                  {t('Please check the URL in the address bar and try again.')}
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
